import React, { useState } from 'react';

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [selectedCollaborator, setSelectedCollaborator] = useState('');
  const [error, setError] = useState('');
  const [showCollaborators, setShowCollaborators] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const collaborators = [
    {
      id: 'elvin',
      name: 'Elvin Atwine',
      role: 'Project Director',
      initials: 'EA'
    },
    {
      id: 'michael',
      name: 'Michael Susi',
      role: 'Rest and Recovery Specialist',
      initials: 'MS'
    },
    {
      id: 'justin',
      name: 'Justin King',
      role: 'Speed Training Coach',
      initials: 'JK'
    },
    {
      id: 'gym-owner',
      name: 'Gym Owner',
      role: 'Facility Partner',
      initials: 'GO'
    }
  ];

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (password === 'Athletesfirst') {
      setShowCollaborators(true);
      setError('');
    } else {
      setError('Incorrect password');
    }
  };

  const handleLogin = () => {
    if (selectedCollaborator) {
      const collaborator = collaborators.find(c => c.id === selectedCollaborator);
      onLogin(collaborator);
    }
  };

  if (!showCollaborators) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-spi-600 via-spi-700 to-spi-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full">
          <div className="bg-white rounded-lg shadow-xl p-8">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-light text-gray-900 mb-2">
                Collaborator Access
              </h1>
              <p className="text-gray-600">
                Enter password to access the admin dashboard
              </p>
            </div>

            <form onSubmit={handlePasswordSubmit} className="space-y-6">
              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                  Password
                </label>
                <div className="relative">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-spi-500 focus:border-spi-500 transition-colors"
                    placeholder="Enter admin password"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 transition-colors"
                  >
                    {showPassword ? (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                      </svg>
                    ) : (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              {error && (
                <div className="text-red-600 text-sm text-center bg-red-50 py-2 px-3 rounded-lg">
                  {error}
                </div>
              )}

              <button
                type="submit"
                className="w-full bg-spi-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-spi-700 transition-colors"
              >
                Continue
              </button>
            </form>

            <div className="mt-6 text-center">
              <p className="text-xs text-gray-500">
                Authorized personnel only
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-spi-600 via-spi-700 to-spi-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-lg w-full">
        <div className="bg-white rounded-lg shadow-xl p-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-light text-gray-900 mb-2">
              Select Your Identity
            </h2>
            <p className="text-gray-600">
              Choose your collaborator profile to continue
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 mb-8">
            {collaborators.map((collaborator) => (
              <div
                key={collaborator.id}
                onClick={() => setSelectedCollaborator(collaborator.id)}
                className={`p-4 border rounded-lg cursor-pointer transition-all duration-200 hover:shadow-md ${
                  selectedCollaborator === collaborator.id
                    ? 'border-spi-500 bg-spi-50 shadow-md'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-spi-600 text-white rounded-lg flex items-center justify-center font-medium mr-4">
                    {collaborator.initials}
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-900">
                      {collaborator.name}
                    </h3>
                    <p className="text-sm text-gray-600">
                      {collaborator.role}
                    </p>
                  </div>
                  <div className="ml-4">
                    {selectedCollaborator === collaborator.id && (
                      <svg className="w-5 h-5 text-spi-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={handleLogin}
            disabled={!selectedCollaborator}
            className="w-full bg-spi-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-spi-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            Enter Admin Dashboard
          </button>

          <div className="mt-6 text-center">
            <button
              onClick={() => setShowCollaborators(false)}
              className="text-sm text-gray-500 hover:text-gray-700"
            >
              Back to password
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;